import { useContext } from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import { Box } from '@mui/material';
import ErrorPage from '../components/common/ErrorPage';

import ExtractionBatchDetails from '../components/extractionBatches/details/ExtractionBatchDetails';
import ExtractionBatchHeader from '../components/extractionBatches/ExtractionBatchHeader';
import TopBar from '../components/common/TopBar';
import errorResponses from '../errorResponses';
import useSetOrg from '../components/hooks/useSetOrg';
import { AppContext } from '../App';
import { useParams } from 'react-router';
import { useSetTitle } from '../components/hooks/useSetTitle';
import { DocumentContextProvider } from '../context/DocumentContext';
import useGetExtractionBatch from '../components/hooks/useGetExtractionBatch';

const ExtractionBatchDetailsPage = () => {
  const { dpid, id: eid } = useParams<{ dpid: string; id: string }>();
  const { dataPoolLabel } = useContext(AppContext);

  const { loading, error } = useSetOrg(dpid);

  const { data: extractionBatch } = useGetExtractionBatch(dpid!, eid!, true);

  useSetTitle(`${extractionBatch?.label || 'Loading...'} - ${dataPoolLabel}`);

  if (loading) return <LinearProgress />;

  if (error) {
    return <ErrorPage error={errorResponses.invalidDataPool} />;
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <TopBar />
      <Box sx={{ bgcolor: '#F5F6FA', px: '40px', pt: '10px' }}>
        <ExtractionBatchHeader
          extractionBatch={extractionBatch}
          dpid={dpid!}
          eid={eid!}
        />
      </Box>
      <Box sx={{ bgcolor: '#F5F6FA', px: '40px', py: '20px', flex: 1 }}>
        <DocumentContextProvider>
          <ExtractionBatchDetails />
        </DocumentContextProvider>
      </Box>
    </Box>
  );
};
export default ExtractionBatchDetailsPage;
